import {
  CREATE_SESSION_FAILURE,
  CREATE_SESSION_SUCCESS,
  DELETE_SESSION_SUCCESS,
  RENEW_ROLE_SUCCESS,
  RENEW_ROLE_FAILURE,
  SessionActionTypes,
  SessionState,
} from './types';

const defaultState: SessionState = {
  isLoading: false,
  isAuthenticated: false,
  errorMessage: "",
  user: null,
};

export default function session(state = defaultState, action: SessionActionTypes): SessionState {
  switch (action.type) {
    case CREATE_SESSION_SUCCESS:
    case RENEW_ROLE_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        ...(action.contents && {
          user: {
            id: action.contents.user.id,
            firstName: action.contents.user.firstName,
            lastName: action.contents.user.lastName,
            role: action.contents.user.role,
            status: action.contents.user.status,
          }
        }),
        errorMessage: '',
      };
    case DELETE_SESSION_SUCCESS:
    case CREATE_SESSION_FAILURE:
    case RENEW_ROLE_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        errorMessage: action.message,
      };
    default:
      return state;
  }
};
